import { render, staticRenderFns } from "./FreeDelivery.vue?vue&type=template&id=54e0f156&scoped=true&"
import script from "./FreeDelivery.vue?vue&type=script&lang=js&"
export * from "./FreeDelivery.vue?vue&type=script&lang=js&"
import style0 from "./FreeDelivery.vue?vue&type=style&index=0&id=54e0f156&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e0f156",
  null
  
)

export default component.exports